(function () {
  "use strict";

  YammerTraineesCtrl.$inject = ['$scope', 'usersResource', '$routeParams', 'yammerService', 'gridFormatters', 'mtypes', '$modal', '$timeout', 'sorting', 'userGridUtils', 'accountFeatures', 'notificationService', 'trainerPrivilege', '$location', '$window'];
  angular
    .module('trainerWebApp.controllers')
    .controller('YammerTraineesCtrl', YammerTraineesCtrl);

  function YammerTraineesCtrl($scope, usersResource, $routeParams, yammerService, gridFormatters, mtypes, $modal,
                              $timeout, sorting, userGridUtils, accountFeatures, notificationService, trainerPrivilege,
                              $location, $window) {

    var courseId = $scope.courseId = $routeParams.courseId;
    var seriesId = $scope.seriesId = $routeParams.seriesId;
    var pageLocation = getPageLocation($routeParams);
    var userRole = trainerPrivilege.roles();

    var queryParams = $location.search();

    $scope.montara = queryParams.course;

    if (!userRole.canInviteUsers || !$scope.yammerEnabled || mfConfig.useGroupRestrictions) {
      if ($scope.courseId)
        $location.path('/TMS/Distribute_Course/' + $scope.courseId + '/trainees');
      else if ($scope.seriesId)
        $location.path('/TMS/Series/' + $scope.seriesId + '/trainees');
      else
        $location.path('/TMS/ManageUsers');
    }

    $scope.isYammerAuthenticated = 'Unknown';

    var data = $scope.resolvedData || {};

    $scope.networks = data.networks || [];
    $scope.yammerGroups = data.yammerGroups || [];
    $scope.yammerGroupCount = data.yammerGroupCount || '';
    $scope.yammerUser = formatAndSortUsers(data.yammerUser || []);
    $scope.yammerAllUser = data.yammerAllUser || [];
    $scope.networkSelect = data.networkSelect || "";
    $scope.traineesToInvite = data.traineesToInvite || 0;
    $scope.courses = data.courses || [];
    $scope.series = data.series || [];
    $scope.groups = data.groups || [];
    $scope.makeCourseRequired = data.makeCourseRequired || true;

    $scope.courseStatus = data.status;

    $scope.viewModel = {
      pageLocation: pageLocation.id,
      courses: [],
      groups: [],
      showCourses: false,
      showGroups: true,
      showSeries: false,
      isManage: pageLocation.id === 'manage'
    };

    $scope.selectCoursesOptions = {
      width: 'off',
      data: [],
      closeOnSelect: false
    };

    $scope.selectGroupsOptions = {
      width: 'off',
      closeOnSelect: false,
      maximumInputLength: 40
    };

    getCoursesSeriesGroups();

    $scope.userModel = createUserModel();

    $scope.data = {
      networks: []
    };

    $scope.selectedGroup = {
      id: -1,
      full_name: 'All',
      members: ''
    };
    var selectedIds = [];

    var groupGridCommands = $scope.groupGridCommands = {};
    var gridCommands = $scope.gridCommands = {};

    function saveYammerTokenAndLoadData(token) {
      yammerService.saveYammerToken(token, function () {
        loadData();
      });
    }

    function loadData() {
      yammerService.getYammerNetworks(function (res) {
        if (!res.isAuthenticated) {
          // yammer javascript has decided not to even bother calling back if logged in with wrong network.
          var timeout = setInterval(function () {
            $scope.isYammerAuthenticated = 'No';
            $scope.$apply();
          }, 6000);
          $window.yam.platform.getLoginStatus(function (response) {
            clearInterval(timeout);
            if (response.authResponse) {
              // TODO: Save token and create yammeruserrefereces (not implemented yet).
              saveYammerTokenAndLoadData(response.access_token.token);
            } else {
              $scope.isYammerAuthenticated = 'No';
              $scope.$apply();
            }
          });

          return;
        }

        $scope.isYammerAuthenticated = 'Yes';

        $scope.networks = res.networks;

        $scope.data.networks = res.networks;

        _.each(res.networks, function (item) {
          $scope.data[item.permalink] = {
            users: [],
            groups: [],
            isLoaded: false,
            lastLoaded: new Date(),
            lastPage: -1,
            groupUsers: {}
          }
        });
      });
    }

    $scope.$watch('traineeSearchCriteria', updateFilter);

    function updateFilter() {
      $scope.filterData = {nameCriteria: $scope.traineeSearchCriteria};
    }

    function filterer(itemToFilter, args) {
      if (!args || !args.nameCriteria) return true;

      var name = userGridUtils.filter.byPersonName(itemToFilter, args.nameCriteria);
      if (!name) {
        return (itemToFilter.email || "").toLowerCase().indexOf(args.nameCriteria.toLowerCase()) >= 0;
      }
      return true;
    }

    loadData();

    $scope.doYammerLogin = function () {
      $window.yam.platform.login(function (resp) {
        if (resp.success) {
          saveYammerTokenAndLoadData(resp.access_token.token);
        } else if (resp.authResponse) {
          saveYammerTokenAndLoadData(resp.access_token.token);
        } else {
          $scope.isYammerAuthenticated = 'No';
          $scope.$apply();
        }
      });
    };

    function getPageLocation(routeParams) {
      var type = {};
      if (routeParams.courseId) {
        type.id = 'course';
        type.url = "#/TMS/Distribute_Course/" + routeParams.courseId + "/trainees";
      } else if (routeParams.seriesId) {
        type.id = 'series';
        type.url = "#/TMS/Series/" + routeParams.seriesId + "/trainees";
      } else {
        type.id = 'manage';
        type.url = '#/TMS/ManageUsers/';
      }
      return type;
    }

    $scope.showExternalNetworks = function () {
      return $scope.data.networks && $scope.data.networks.length > 1;
    }

    //networks
    $scope.networkSelected = function () {

      if (!$scope.data.networks || $scope.data.networks.length == 0) {
        // Networks are not loaded yet.
        return;
      }

      if (!$scope.networkSelect)
        $scope.networkSelect = $scope.data.networks[0].permalink;
      // select the first network


      if (!$scope.data[$scope.networkSelect].isLoaded)
        showSpinner();
      getGroupList($scope.networkSelect);
      getAllYammerUsers($scope.networkSelect, 0);
    };

    function getGroupList(permalink) {

      if ($scope.data[permalink] && $scope.data[permalink].isLoaded) {
        $scope.yammerGroups = $scope.data[permalink].groups;
        updateAllGroupUserCount(permalink);
        return;
      }

      yammerService.getYammerGroups(permalink, function (result) {
        if (!result.isAuthenticated) return;
        $scope.yammerGroups = result.groups;
        $scope.yammerGroupCount = $scope.yammerGroups.length;

        $scope.data[permalink].groups = result.groups;

        _.each(result.groups, function (item) {
          $scope.data[permalink].groupUsers[item.id] = {
            isLoaded: false,
            lastPage: 0,
            users: []
          };
        });

        $scope.selectedGroup = {
          id: -1,
          full_name: 'All',
          members: ''
        };

        if ($scope.yammerGroups) {
          $scope.yammerGroups.splice(0, 0, $scope.selectedGroup);
        }

        updateAllGroupUserCount(permalink);
      });
    }

    $scope.gridInfoGroups = {
      options: {
        editable: false,
        selectable: true,
        enableCellNavigation: true,
        asyncEditorLoading: false,
        enableColumnReorder: false,
        forceFitColumns: true,
        forceSyncScrolling: $scope.yammerGroups.length < 100
      },
      columns: [
        {
          id: "name",
          name: "Groups",
          field: "full_name", width: 300,
          cssClass: "cell-title",
          formatter: gridFormatters.yammerGroupNameFormatter,
          headerCssClass: "bold"
        }
      ],
      onClick: onGroupRowClick,
      rowMetadataProvider: groupRowMetadataProvider,
      data: []
    };

    function groupRowMetadataProvider(row) {
      if (!this.getItem(row))
        return {cssClasses: 'shiftedRow'};
      return this.getItem(row).full_name.toLowerCase() === 'all' ? {cssClasses: 'boldedRow'} : {cssClasses: 'shiftedRow'};
    }

    function updateAllGroupUserCount(permalink) {
      if ($scope.networkSelect != permalink) return;
      if (!$scope.yammerGroups || $scope.yammerGroups.length == 0) {
        return;
      }

      var group = $scope.yammerGroups[0];
      group.members = $scope.data[permalink].users.length.toString();

      var item = groupGridCommands.getItem(0);

      if (item) {
        groupGridCommands.updateItem(item.id, group);
      }
    }

    function callGetYammerUsersEndpoint(permalink, pageId, cb) {
      var yammerOptions = {permalink: permalink, pageId: pageId};

      if ($scope.courseId) {
        yammerService.getYammerCourseUsers($scope.courseId, yammerOptions, cb);
      } else if ($scope.seriesId) {
        yammerService.getYammerCourseUsers($scope.seriesId, yammerOptions, cb);
      } else {
        yammerService.getYammerUsers(yammerOptions, cb);
      }
    }

    function dataLoaded() {
      hideSpinner();

      //Sometimes slickgrid needs a kick if sizes of things changed significantly
      setTimeout(function () {
        $scope.$broadcast('resized');
        $scope.$apply();
      }, 50);
    }

    function getAllYammerUsers(permalink, pageId) {
      if ($scope.data[permalink].isLoaded) {

        $scope.yammerUser = formatAndSortUsers($scope.data[permalink].users);
        updateAllGroupUserCount(permalink);
        dataLoaded();
        return;
      }

      if ($scope.data[permalink].lastPage < 1) {
        $scope.data[permalink].lastPage = pageId < 1 ? 1 : pageId;
      }


      callGetYammerUsersEndpoint(permalink, $scope.data[permalink].lastPage, function (result) {

        $scope.data[permalink].users = $scope.data[permalink].users.concat(result.users);

        $scope.data[permalink].lastLoaded = new Date();
        $scope.data[permalink].lastPage = result.nextPage;
        $scope.data[permalink].isLoaded = !result.hasMore;

        if ($scope.networkSelect != permalink) {
          return;
        }

        if ($scope.selectedGroup.id < 0) {
          $scope.yammerUser = formatAndSortUsers($scope.data[permalink].users);
        }

        updateAllGroupUserCount(permalink);

        if (result.hasMore) {
          getAllYammerUsers(permalink, $scope.data[permalink].lastPage);
        }

        if ($scope.data[permalink].isLoaded) {
          dataLoaded();
        }

      });
    }

    //get users for a group
    function onGroupRowClick(item) {
      if ($scope.selectedGroup.id == item.id) {
        return;
      }
      $scope.selectedGroup = item;

      return loadTraineesForGroup(item);
    }

    function getYammerUsersInGroup(groupId, options) {
      options = _.defaults(options, {permalink: '', pageId: 1, groupId: groupId});

      var permalink = options.permalink;
      var pageId = options.pageId;

      if ($scope.data[permalink].groupUsers[groupId].isLoaded) {
        $scope.yammerUser = formatAndSortUsers($scope.data[permalink].groupUsers[groupId].users);
        return;
      }

      if ($scope.data[permalink].groupUsers[groupId].lastPage <= 0) {
        $scope.data[permalink].groupUsers[groupId].lastPage = pageId || 1;
      }

      yammerService.getYammerUsersInGroup(groupId, options, function (result) {

        $scope.data[permalink].groupUsers[groupId].users = $scope.data[permalink].groupUsers[groupId].users.concat(result.users);

        $scope.data[permalink].groupUsers[groupId].users = _.filter($scope.data[permalink].users, function (item) {
          return _.size(_.filter($scope.data[permalink].groupUsers[groupId].users, function (filteredByItem) {
              return filteredByItem.id == item.id
            })) > 0
        })

        $scope.data[permalink].groupUsers[groupId].lastPage += 1;
        $scope.data[permalink].groupUsers[groupId].isLoaded = !result.hasMore;

        if ($scope.networkSelect != permalink) {
          return;
        }

        if ($scope.selectedGroup.id == groupId) {
          $scope.yammerUser = formatAndSortUsers($scope.data[permalink].groupUsers[groupId].users);
        }

        if (result.hasMore) {

          options.pageId = $scope.data[permalink].groupUsers[groupId].lastPage;
          getYammerUsersInGroup(groupId, options);
        }

      });
    }

    function formatAndSortUsers(users) {
      _.each(users, function (user) {
        user.fullNameLastFirst = user.lastName + ', ' + user.firstName;
      });
      return users.sort(sorting.byName('fullNameLastFirst'));
    }

    $scope.gridInfoYammerUsers = {
      options: {
        editable: false,
        enableCellNavigation: true,
        enableColumnReorder: false,
        forceFitColumns: true,
        multiColumnSort: true,
        forceSyncScrolling: $scope.yammerUser.length < 100
      },
      columns: [
        {
          id: "image",
          name: "",
          field: "mugshotUrl",
          width: 40,
          cssClass: "cell-title cell-trainee-image",
          resizable: false,
          headerCssClass: "header-column",
          formatter: gridFormatters.traineeImageFormatter
        },
        {
          id: "name",
          name: "Name",
          field: "fullNameLastFirst",
          width: 250,
          cssClass: "cell-title",
          headerCssClass: "header-column",
          sortable: true
        },
        {
          id: "email",
          name: "Email",
          field: "email",
          width: 250,
          cssClass: "cell-title",
          headerCssClass: "header-column",
          sortable: true
        }
      ],
      onRowsChanged: onRowsChanged,
      onRowCountChanged: onRowCountChanged,
      onClick: onTraineeRowClick,
      filterFn: filterer,
      rowMetadataProvider: traineeRowMetadataProvider,
      data: [],
      includeSelectCheckbox: true,
      checkboxSelectionFormatter: checkboxSelectionFormatter,
      onSelectedRowsChanged: onSelectedRowsChanged
    };

    var viewData = [];

    function onRowCountChanged(args, items) {
      viewData = items;
      $scope.yammerUserInGroupCount = viewData.length;
      refreshInviteButtonState();
    }

    function onRowsChanged(args, items) {
      viewData = items;
      refreshInviteButtonState();
    }

    function onSelectedRowsChanged(args, value) {
      $scope.selectedRowsCount = value.length;
      selectedIds = value;

      refreshInviteButtonState();
    }

    function calculateTraineesToInvite() {
      var traineesToInvite = 0;
      _.each(viewData, function (yammerUser) {
        if (canBeInvited(yammerUser) && selectedIds.indexOf(yammerUser.id) != -1) {
          traineesToInvite++;
        }
      });
      $scope.traineesToInvite = traineesToInvite;

    }

    function canBeInvited(user) {
      if ($scope.viewModel.isManage) {
        return (!user.state || (user.state != 'invited' && user.state != 'archived' && user.state != 'inPortal'));
      } else {
        return (!user.state || (user.state != 'invited' && user.state != 'archived'));
      }
    }


    function traineeRowMetadataProvider(row) {
      if (!this.getItem(row))
        return {cssClasses: 'enabledRow'};
      if ($scope.viewModel.isManage)
        return (this.getItem(row).state && (this.getItem(row).state == "invited" || this.getItem(row).state == "archived" || this.getItem(row).state == "inPortal")) ? {cssClasses: 'disabledRow'} : {cssClasses: 'enabledRow'};
      else
        return (this.getItem(row).state && (this.getItem(row).state == "invited" || this.getItem(row).state == "archived")) ? {cssClasses: 'disabledRow'} : {cssClasses: 'enabledRow'};
    }

    function filterSampleCourse(courses) {
      if (!~accountFeatures.features.indexOf(mtypes.featureEntry.trainerHTMLHome)) {
        return _.filter(courses, function (item) {
          return item.id != mfConfig.sampleCourseId;
        });
      }

      return courses;
    }

    function getCoursesSeriesGroups() {
      usersResource.getAddUserSetupForManage(function (result) {
        $scope.courses = _.map(filterSampleCourse(result.courses), function (value) {
          return {id: value.id, text: value.name, type: mtypes.courseType.online}
        });

        $scope.series = _.map(result.series, function (value) {
          return {id: value.id, text: value.name, type: mtypes.courseType.series}
        });
        $scope.groups = _.map(result.groups, function (value) {
          return {id: value.id, text: value.name}
        });

        $scope.viewModel.courses = $scope.courses.concat($scope.series);
        $scope.viewModel.groups = $scope.groups;
        $scope.viewModel.showSeries = !_.isEmpty($scope.series);

        if ($scope.viewModel.courses.length > 0) $scope.viewModel.showCourses = true;

        setupCourseSeriesDropdown();
      });
    }

    function setupCourseSeriesDropdown() {
      $scope.selectCoursesOptions.data.push({text: 'Courses', children: $scope.courses});

      if ($scope.viewModel.showSeries)
        $scope.selectCoursesOptions.data.push({text: 'Series', children: $scope.series});
    }

    function createUserModel() {
      return {
        courses: null,
        groups: null
      };
    }

    $scope.clearAllCourses = function () {
      $scope.userModel.courses = null;
    };

    $scope.clearAllGroups = function () {
      $scope.userModel.groups = null;
    };

    function refreshData(cb) {
      cb = cb || function () {
      };

      restoreSelectedGroup();
      cb();
    }

    function restoreSelectedGroup() {
      var updatedSelectedGroup = $.grep($scope.yammerGroups, function (e) {
        return e.id == $scope.selectedGroup.id
      });
      loadTraineesForGroup(updatedSelectedGroup[0]);
    }

    function loadTraineesForGroup(item) {
      if ($scope.selectedGroup.id < 0)
        $scope.yammerUser = $scope.data[$scope.networkSelect] ? formatAndSortUsers($scope.data[$scope.networkSelect].users) : null;
      else
        getYammerUsersInGroup(item.id, {permalink: $scope.networkSelect});

      viewData = $scope.yammerUser;
      gridCommands.cleanSelection();
    }

    function checkboxSelectionFormatter(row, cell, value, columnDef, dataContext) {
      if ($scope.viewModel.isManage) {
        if (dataContext && dataContext.state && (dataContext.state == "invited" || dataContext.state == "archived" || dataContext.state == "inPortal")) return "";
      }
      else {
        if (dataContext && dataContext.state && (dataContext.state == "invited" || dataContext.state == "archived")) return "";
      }

      var selectedRows = gridCommands.getSelectedRows();
      var checked = !!~selectedRows.indexOf(row);
      return checked ? "<input type='checkbox' checked='checked'>" : "<input type='checkbox'>";
    }

    function onTraineeRowClick(item, targetClasses) {
      // omgwtf
    }

    var spinnerTimeout;
    var inviting = false;

    function refreshInviteButtonState() {
      calculateTraineesToInvite();
      buildInviteAndAddButtonText();
    }

    function buildInviteAndAddButtonText() {
      var label = inviting ? "Inviting... (" + $scope.traineesToInvite + ')' : $scope.traineesToInvite == 0 || $scope.traineesToInvite == 1 ? 'Invite' : 'Invite (' + $scope.traineesToInvite + ')';

      var addLabel = inviting ? "Adding... (" + $scope.traineesToInvite + ')' : $scope.traineesToInvite == 0 || $scope.traineesToInvite == 1 ? 'Add Trainees' : 'Add Trainees (' + $scope.traineesToInvite + ')';

      $scope.inviteButtonState = {
        enabled: $scope.traineesToInvite > 0 && !inviting,
        text: label
      };

      $scope.addButtonState = {
        enabled: $scope.traineesToInvite > 0 && !inviting,
        text: addLabel
      };
    }

    buildInviteAndAddButtonText();

    function clearAfterInvite() {
      inviting = false;
      clearTimeout(spinnerTimeout);
      //    hideSpinner();
      gridCommands.cleanSelection();
//      preselectInvitedTrainees();
      refreshInviteButtonState();
    }

    $scope.addTrainees = function (model) {
      var idsToInvite = selectedIds;
      var coursesToInvite = courseId ? [courseId] : [];
      var seriesToInvite = seriesId ? [seriesId] : [];
      var groupsToInvite = [];
      var usersToInvite = [];

      for (var i = 0; i < $scope.data[$scope.networkSelect].users.length; i++) {
        var user = $scope.data[$scope.networkSelect].users[i];
        if (canBeInvited(user) && selectedIds.indexOf(user.id) > -1) {
          usersToInvite.push({
            firstName: user.firstName,
            lastName: user.lastName,
            email: user.email,
            yammerId: user.id
          });
        }
      }

      if (model) {
        seriesToInvite = _.pluck(_.filter(model.courses, function (value) {
          return value.type == mtypes.courseType.series;
        }), 'id');
        coursesToInvite = _.pluck(_.filter(model.courses, function (value) {
          return value.type == mtypes.courseType.online;
        }), 'id');

        groupsToInvite = _.pluck(model.groups, 'id');
      }

      if (idsToInvite.length == 0) return;
      inviting = true;
      buildInviteAndAddButtonText();

      var date = new Date();
      var dateString = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();

      var options = {
        permalink: $scope.networkSelect,
        courseIds: $scope.makeCourseRequired ? [] : coursesToInvite,
        requiredCourseIds: $scope.makeCourseRequired ? coursesToInvite : [],
        seriesIds: seriesToInvite,
        clientDatestamp: dateString,
        users: usersToInvite,
        groupIds: groupsToInvite
      };


      yammerService.inviteYammerUsers(options, function (result) {
        if (result.users) {
          for (var i = 0; i < result.users.length; i++) {
            var resUser = result.users[i];
            for (var j = 0; j < $scope.data[$scope.networkSelect].users.length; j++) {
              var dataUser = $scope.data[$scope.networkSelect].users[j];
              if (resUser.yammerId == dataUser.id || (resUser.email || '').toLowerCase() == (dataUser.email || ' ').toLowerCase()) {
                dataUser.state = resUser.state;
              }
            }
          }
        }

        refreshData(clearAfterInvite);
        var invitationGrammer = idsToInvite.length > 1 ? 'invitations' : 'invitation';

        if ($scope.seriesId) {
          var notification = {
            message: idsToInvite.length + ' series ' + invitationGrammer + ' sent.',
            pageToShow: 'Series',
            close: true,
            displayOrder: 2
          };
          notificationService.setNotification(notification);
          $timeout(function () {
            notificationService.removeNotification(notification);
          }, 5000);
        }
        else if ($scope.courseId) {
          var notification = $scope.courseStatus == 107000100 ?
          {
            message: idsToInvite.length + ' course ' + invitationGrammer + ' will be sent once the course is activated.',
            pageToShow: 'Course',
            close: true,
            displayOrder: 2
          } :
          {
            message: idsToInvite.length + ' course ' + invitationGrammer + ' sent.',
            pageToShow: 'Course',
            close: true,
            displayOrder: 2
          };
          notificationService.setNotification(notification);
          $timeout(function () {
            notificationService.removeNotification(notification);
          }, 5000);
        }
      }, function (error) {
        clearAfterInvite(true);
      });
    };

    var yammerLoadingDialog;

    function showSpinner() {
      yammerLoadingDialog = $modal.open({
        keyboard: false,
        backdropClick: false,
        templateUrl: 'pages/yammer/yammerLoading.html',
        controller: ['$scope', function ($scope) {
        }]
      });
    }

    function hideSpinner() {
      $timeout(function () {
        if (yammerLoadingDialog)  yammerLoadingDialog.close();
        yammerLoadingDialog = null;
      }, 1);
      //$rootScope.$broadcast('$showLoadingSpinner', false);
      //refreshInviteButtonState();
    }

  }

})();
